export default {
    // API_ENDPOINT: 'http://192.168.68.135:8000',
    API_ENDPOINT: 'https://crowdq-api.orfactor.com',
};
